import { Image } from "./image";
import { setting } from "../Config/Config";
import { Link } from "react-router-dom";
export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2 style={{ color: setting.blue }}>Our Portfolio</h2>
          <Link to="/projectsList" style={{ color: setting.orange }}>
            All Projects
          </Link>{" "}
          -{" "}
          <Link to="/customersList" style={{ color: setting.orange }}>
            All Customers
          </Link>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      desc={d.description}
                      date={d.date}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
